import cloneDeep from "lodash-es/cloneDeep";
import get from "lodash-es/get";
import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { GET_FORM_VALIDATION_SUGGESTS } from "graphqlQueries/suggests";
import { buildValidator } from "utils/buildValidator";

export default function useFormValidator(
  mutationName,
  labels,
  extendValidator = {},
  fieldExtensions = {},
) {
  const { data } = useQuery(GET_FORM_VALIDATION_SUGGESTS, {
    fetchPolicy: "cache-only",
  });

  const validationSchema = useMemo(() => {
    const validationParams = cloneDeep(
      get(data, `suggestions.validators.${mutationName}`, {}),
    );
    Object.entries(validationParams).forEach(([key, value]) => {
      value.label = labels[key];

      if (fieldExtensions[key]) {
        const adornment = fieldExtensions[key];
        value.transform = (val) => (val ? val + adornment : adornment);
      }
    });
    return buildValidator(validationParams, extendValidator);
  }, [data, mutationName, labels, extendValidator, fieldExtensions]);

  return { validationSchema };
}
